import recolteApi from '@/api/recolte.api'

const getDefaultState = () => {
  return {
    /*
     *{
     *  "anneeRecolte":"2020",
     *  "recoltesGraine":[
     *    {
     *      "resume":{
     *        "anneeRecolte":"2020",
     *        "codeIdaRs3":"BT",
     *        "cumulPoidsNetEnKg":450840,
     *        "cumulPoidsAuxNormesEnKg":449930,
     *        "analyseMoyenne":{ },
     *        "dateDerniereLivraison":"2020-09-23"
     *      },
     *      "recoltesMois":[
     *        {
     *          "resume":{
     *            "anneeRecolte":"2020",
     *            "codeIdaRs3":"BT",
     *            "cumulPoidsNetEnKg":444960,
     *            "cumulPoidsAuxNormesEnKg":444060,
     *            "analyseMoyenne":{  },
     *            "dateDerniereLivraison":"2020-07-27",
     *            "mois":"2020-07",
     *          },
     *          "recoltesJour":[
     *            {
     *              "resume":{
     *                "anneeRecolte":"2020",
     *                "codeIdaRs3":"BT",
     *                "cumulPoidsNetEnKg":40140,
     *                "cumulPoidsAuxNormesEnKg":40050,
     *                "analyseMoyenne":{ },
     *                "dateDerniereLivraison":"2020-07-13",
     *                "jour":"2020-07-13",
     *              },
     *              "apports":[
     *                {
     *                  "dateApport":"2020-07-13",
     *                  "numeroBon":7851708,
     *                  "anneeRecolte":"2020",
     *                  "codeIdaRs3":"BT",
     *                  "siloDestination":{
     *                    "code":"OS60",
     *                    "libelle":"Rouvres"
     *                  },
     *                  "poidsNetEnKg":12620,
     *                  "poidsAuxNormesEnKg":12590,
     *                  "caracteristiques":{
     *                    "humiditeTaux":12.5,
     *                    "impureteTaux":0.2,
     *                    "proteineTaux":10.3,
     *                    "poidsSpecifiqueEnKgParHectolitre":81.6
     *                  }
     *                }
     *              ]
     *            }
     *          ]
     *        }
     *      ]
     *    }
     *  ]
     *}
     */
    recolte: {
      recoltesGraine: []
    },
    /*
      [{
          "codeIdaRs3": "CO",
          "resumeRecolteDto": {
            "anneeRecolte": "2021",
            "cumulPoidsNetEnKg": 120160,
            "cumulPoidsAuxNormesEnKg": 119960,
            "analyseMoyenne": {
              "daturaPresent": false,
              "ergotPresent": false,
              "flairAnormal": false,
              "humiditeTaux": 8.282794264754918,
              "impureteTaux": 1.736645548516172,
              "insectePresent": false
            },
            "dateDerniereLivraison": "2021-08-04"
        }
      },
      {
        "codeIdaRs3": "TOTAL",
        "resumeRecolteDto": {
          "anneeRecolte": "2021",
          "cumulPoidsNetEnKg": 748900,
          "cumulPoidsAuxNormesEnKg": 747020,
          "analyseMoyenne": {
            "daturaPresent": false,
            "ergotPresent": false,
            "flairAnormal": false,
            "humiditeTaux": 12.415557816390459,
            "impureteTaux": 0.44703086932076785,
            "insectePresent": false,
            "proteineTaux": 11.006385116917496,
            "poidsSpecifiqueEnKgParHectolitre": 67.18504608809364
          },
          "dateDerniereLivraison": "2021-11-04"
        }
      }
    ] */
    resumeRecolteParGraine: [],
    resumeRecolteApportParGraine: [],
    repartitionApportParGraine: {},
    quantiteContractualiseeRecolteEnCours: null,
    quantiteContractualiseeProchaineRecolte: null,
    anneeRecolteSelected: null,
    anneesRecolteContractualiseesEtRecoltees: []
  }
}
const module = {
  namespaced: true,
  state: getDefaultState(),

  getters: {
    recolte (state) {
      return state.recolte
    },
    resumeRecolteParGraine (state) {
      return state.resumeRecolteParGraine
    },
    resumeRecolteApportParGraine (state) {
      return state.resumeRecolteApportParGraine
    },
    repartitionApportParGraine (state) {
      return state.repartitionApportParGraine
    },
    anneeRecolteSelected (state) {
      return state.anneeRecolteSelected
    },
    listeAnneesRecoltes (state) {
      return state.anneesRecolteContractualiseesEtRecoltees
    }
  },

  mutations: {
    UPDATE_RECOLTE (state, recolte) {
      state.recolte = recolte
    },
    UPDATE_RESUME_RECOLTE_PAR_GRAINE (state, resumeRecolteParGraine) {
      state.resumeRecolteParGraine = resumeRecolteParGraine
    },
    UPDATE_RESUME_APPORT_RECOLTE_PAR_GRAINE (state, resumeRecolteApportParGraine) {
      state.resumeRecolteApportParGraine = resumeRecolteApportParGraine
    },
    UPDATE_REPARTITION_APPORT_PAR_GRAINE (state, repartitionApportParGraine) {
      state.repartitionApportParGraine = repartitionApportParGraine
    },
    UPDATE_ANNEE_RECOLTE_SELECTED (state, anneeRecolteSelected) {
      state.anneeRecolteSelected = anneeRecolteSelected
    },
    UPDATE_RECOLTES (state, anneesRecolteContractualiseesEtRecoltees) {
      state.anneesRecolteContractualiseesEtRecoltees = anneesRecolteContractualiseesEtRecoltees
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    fetchRecolte ({ commit, rootGetters }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return recolteApi.getRecolte(username, anneeRecolte, null, null, null, null, null).then(result => {
        commit('UPDATE_RECOLTE', result)
        return result
      })
    },
    fetchRecolteByAnnee ({ commit, rootGetters }, params) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return recolteApi.getRecolte(username,
        params.anneeRecolte,
        params.filtreNumeroBonApport,
        params.filtreTypeContratApport,
        params.filtreNumeroContratApport,
        params.filtreMoisApport,
        params.filtreGraineValoriseeApport).then(result => {
          commit('UPDATE_RECOLTE', result)
          return result
        })
    },
    fetchResumeApportRecolteParGraine ({ commit, rootGetters }, nbApports) {
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return recolteApi.getResumeApportRecolteParGraine(username, anneeRecolte, nbApports).then(result => {
        commit('UPDATE_RESUME_APPORT_RECOLTE_PAR_GRAINE', result)
        return result
      })
    },
    fetchRepartitionApportParGraine ({ commit, rootGetters }, data) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return recolteApi.getRepartitionApportParGraine(username, data.anneeRecolteSelected, data.codeGraineRs3Selected).then(result => {
        commit('UPDATE_REPARTITION_APPORT_PAR_GRAINE', result)
        return result
      })
    },
    fetchRecoltesContractualiseesEtRecoltees ({ commit, rootGetters }, numtiers) {
      let username
      if (numtiers) {
        username = numtiers
      } else if (rootGetters['adherent/numtiers']) {
        username = rootGetters['adherent/numtiers']
      } else {
        username = rootGetters['user/profil'].username
      }
      return recolteApi.getRecoltesContractualiseesEtRecoltees(username).then(result => {
        commit('UPDATE_RECOLTES', result)
        return result
      })
    },
    getPdfApport ({ rootGetters }, data) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      return recolteApi.getPdfApport(username, data.moisDebut, data.moisFin, data.graineRs3)
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
